import MessageSender from '../sender'
import BaseMessage from '../message'

export default (usernameAgen) => async () => {
  const msg = new BaseMessage()

  msg.setPath('/control/credential_server')
  msg.setItem('username_agen', usernameAgen)

  const response = await new MessageSender().doGet(msg)

  return response
}
